






















import Vue, { PropType } from 'vue';

// export type DataType = {
//   innerValue: string;
// }

export default Vue.extend({
  name: 'GTextarea',
  props: {
    value: { type: String as PropType<string>, default: '' },
    rows: { type: Number as PropType<number>, default: 3 },
    name: { type: String as PropType<string>, required: true },
    placeholder: { type: String as PropType<string>, default: '' },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    maxLength: { type: Number as PropType<number>, default: 0 },
    underline: { type: Boolean as PropType<boolean>, default: false },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    error: { type: Array as PropType<string[]>, default: () => [] },
  },
  // data(): DataType {
  //   return {
  //     innerValue: this.value,
  //   };
  // },
  watch: {
    innerValue(val: string) {
      if (val && val.length > this.maxLength) {
        this.innerValue = val.substr(0, this.maxLength);
      }
    },
  },
  computed: {
    innerValue: {
      get(): string {
        return this.value;
      },
      set(val: string): void {
        this.$emit('input', val);
      },
    },
  },
});
